import React, {useEffect, useState} from 'react';

import {AnimatePresence, motion} from 'framer-motion';

import {
    logoWrap,
    progress,
    progressBar,
    shimmer,
    splash,
    splashHint,
    splashLogo,
    stage,
} from './splash-screen.module.styl';

const MIN_DISPLAY_MS = 1000;

type Props = {
    isReady: boolean,
    logoSrc: string,
};

export const SplashScreen: React.FC<Props> = ({isReady, logoSrc}) => {
    const [minTimeElapsed, setMinTimeElapsed] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => setMinTimeElapsed(true), MIN_DISPLAY_MS);
        return () => clearTimeout(timer);
    }, []);

    const visible = !isReady || !minTimeElapsed;

    return (
        <AnimatePresence>
            {visible ? (
                <motion.div
                    className={splash}
                    role="status"
                    aria-live="polite"
                    aria-label="Loading"
                    initial={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={{duration: 0.35, ease: 'easeInOut'}}>
                    <motion.div
                        className={stage}
                        initial={{opacity: 0, y: 6, scale: 0.99}}
                        animate={{opacity: 1, y: 0, scale: 1}}
                        transition={{duration: 0.45, ease: 'easeOut'}}>
                        <div className={logoWrap}>
                            <img
                                src={logoSrc}
                                alt="PitchBook"
                                className={splashLogo}
                            />
                            <span className={shimmer} aria-hidden="true"/>
                        </div>

                        <div className={progress} aria-hidden="true">
                            <span className={progressBar}/>
                        </div>

                        <motion.div
                            className={splashHint}
                            initial={{opacity: 0}}
                            animate={{opacity: 0.75}}
                            transition={{delay: 0.15, duration: 0.35}}>
                            Loading…
                        </motion.div>
                    </motion.div>
                </motion.div>
            ) : null}
        </AnimatePresence>
    );
};
